import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

@observer
export default class RouteNotAllowed extends Component {
    render() {
        return (
            <div style={{ textAlign: 'center', paddingTop: '25px' }}>
                <h2>{i18n.t('surveyBuilder.routeNotAvailable')}</h2>
            </div>
        )
    }
}
